module.exports = __webpack_public_path__ + "img/3-manufactory.7a22309c.jpg";